import { LEGACY_NOINDEX_RELEASE_PATHS } from "./release-route-dispositions.mjs";

/**
 * Reviewed, code-managed source-record exclusions. These do not establish
 * publication, language, ownership, a replacement, or even record existence.
 * A successful authoritative reader must establish those independently.
 */
export const REVIEWED_PUBLICATION_EXCLUSIONS = Object.freeze([
  ...[...LEGACY_NOINDEX_RELEASE_PATHS].map(canonicalPath => Object.freeze({
    canonicalPath, indexable:false, followLinks:false,
    indexabilityReason:"reviewed-release-source-exclusion",
    sourceReference:"approved-phase-one-review:legacy-source-dispositions",
  })),
  Object.freeze({canonicalPath:"/nz/70",indexable:false,followLinks:false,
    indexabilityReason:"reviewed-editorial-source-exclusion",sourceReference:"approved-phase-one-review:editorial"}),
  Object.freeze({canonicalPath:"/ca/get-paid-to-drive-your-classic-car",indexable:false,followLinks:false,
    indexabilityReason:"unapproved-canada-acquisition-source",sourceReference:"approved-phase-one-review:canada-acquisition"}),
]);

export function authoritativeRecordIndexability(record) {
  if(typeof record.indexable!=="boolean" || !record.indexable && !record.indexabilityReason)
    throw Error("Authoritative record indexability is incomplete");
  const exclusion=REVIEWED_PUBLICATION_EXCLUSIONS.find(row=>row.canonicalPath===record.canonicalPath);
  return exclusion ? {...record,indexable:false,followLinks:exclusion.followLinks,
    indexabilityReason:exclusion.indexabilityReason,indexabilitySource:exclusion.sourceReference} : record;
}

/** Exactly one projection for headers, HTML, sitemap and client metadata. */
export function recordRobots(record,{markdown=false}={}) {
  if(typeof record.indexable!=="boolean" || !record.indexable && !record.indexabilityReason)
    throw Error("Authoritative record indexability is incomplete");
  const indexable=record.publication==="published" && record.indexable && !markdown;
  return {indexable,robots:`${indexable?"index":"noindex"}, ${record.followLinks===false?"nofollow":"follow"}`,
    reason:markdown?"non-html-representation":record.indexabilityReason||"published-indexable"};
}
